import CustomMarker from './custom-marker';
export default CustomMarker;